module.exports = __webpack_public_path__ + "img/icon_line.c5b29f8a.svg";